/** i18next bootstrap for dev-portal. EN + RU. Languages mirror tenant-frontend. */
import i18n from "i18next";
import {initReactI18next} from "react-i18next";

import en from "/locales/en.json";
import ru from "/locales/ru.json";

void i18n
    .use(initReactI18next)
    .init({
        resources: {en: {translation: en}, ru: {translation: ru}},
        lng: "en",
        fallbackLng: "en",
        interpolation: {escapeValue: false},
    });

export {useTranslation} from "react-i18next";
export default i18n;
